import React from "react";
import { Field } from "formik";
import { FaWheelchair, FaKitMedical, FaClipboardList } from "react-icons/fa6";
import FormField from "../components/FormField";

export const StepMobiliteSante = () => (
  <div className="flex flex-col gap-3 step-enter">
    <div>
      <h2 className="text-base font-bold text-foreground">Accessibilité & santé</h2>
      <p className="text-xs text-muted-foreground mt-0.5">À lire avec attention — voir l'explication ci-dessous.</p>
    </div>

    {/* PMR — carte claire avec vrai interrupteur, plus lisible qu'une case à cocher */}
    <Field name="pmr">
      {({ field, form }) => {
        const on = field.value === true;
        return (
          <button
            type="button"
            onClick={() => form.setFieldValue("pmr", !on)}
            className="flex items-center gap-3 rounded-xl border px-4 py-3 text-left transition-all duration-150 w-full"
            style={on ? { borderColor: "var(--acc)", background: "var(--acc-soft)" } : { borderColor: "var(--line-2)" }}
          >
            <div
              className="w-10 h-10 rounded-full flex items-center justify-center shrink-0"
              style={{ background: on ? "var(--acc)" : "var(--acc-soft)" }}
            >
              <FaWheelchair className="h-[18px] w-[18px]" style={{ color: on ? "var(--acc-fg)" : "var(--acc)" }} />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-bold">PMR — mobilité réduite</p>
              <p className="field-hint mt-0.5">Pour anticiper, si besoin, un accès adapté lors des événements.</p>
            </div>
            <span
              className="relative shrink-0 rounded-full transition-colors duration-200"
              style={{ width: 42, height: 24, background: on ? "var(--acc)" : "hsl(var(--muted-foreground) / 0.35)" }}
              aria-hidden="true"
            >
              <span
                className="absolute top-0.5 rounded-full bg-white shadow transition-all duration-200"
                style={{ width: 20, height: 20, left: on ? 20 : 2 }}
              />
            </span>
          </button>
        );
      }}
    </Field>

    {/* Allergies / Informations médicales — accent discret, pas de gros bloc coloré */}
    <div style={{ borderLeft: "3px solid var(--req)", paddingLeft: 14 }}>
      <p className="field-hint mb-2">
        Ces informations ne sont jamais présentes par hasard : en cas de malaise, d'accident ou de prise en charge
        médicale lors d'une convention, elles peuvent être essentielles pour une intervention adaptée. Merci de les
        renseigner avec précision, pour votre sécurité et celle des autres membres.
      </p>
      <FormField name="allergies" label="Allergies / Informations médicales" icon={FaKitMedical} as="textarea" rows={2} />
    </div>

    <FormField
      name="notes"
      label="Informations à transmettre au bureau"
      icon={FaClipboardList}
      as="textarea"
      rows={2}
      help="Tout autre point important que l'équipe dirigeante devrait connaître."
    />
  </div>
);
